import updateCancelPolicy from '../../../../actions/siteadmin/CancellationPolicy/updateCancelPolicy';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    dispatch(updateCancelPolicy(values));
}

export default submit;
